import { render, staticRenderFns } from "./yggk.vue?vue&type=template&id=9989abe0&scoped=true&"
import script from "./yggk.vue?vue&type=script&lang=js&"
export * from "./yggk.vue?vue&type=script&lang=js&"
import style0 from "./yggk.vue?vue&type=style&index=0&id=9989abe0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9989abe0",
  null
  
)

export default component.exports